<template>
	<button @click="addTag" type="button" class="sm-button sm-edit-button"><slot></slot></button>
</template>

<script>
export default {
	props: ['tag'],
	methods: {
		addTag: function() {
			this.$emit('tag', this.tag);
		}
	}
};
</script>


// WEBPACK FOOTER //
// TagButton.vue?58fcbaa1